import React, { memo } from 'react';
import { renderBlock } from './blocks';
import type { BlockRenderProps } from './blocks/types';

export type { RenderMergeMode } from './blocks/types';

export const BlockRenderer = memo((
  props: BlockRenderProps,
) => {
  return <>{renderBlock(props)}</>;
});
BlockRenderer.displayName = 'BlockRenderer';
